import { snapshot } from 'valtio'
import { buildAxiosInstance } from '../../../../shared/utils/apiUtils'
import { recurringPaymentProxy } from '../../../../shared/proxies/recurringPaymentProxy'

export async function executeRecurringTransactionDetermineFuturePayments (): Promise<void> {
  const { recurringPayment } = snapshot(recurringPaymentProxy)
  recurringPaymentProxy.linkedRecurringPayments = null
  recurringPaymentProxy.apiCall.loading = true
  recurringPaymentProxy.apiCall.error = null
  try {
    const response = await buildAxiosInstance().post('/api/recurring_payments/determineFuturePayments',
      { futureInstancesCount: 2, recurringPaymentId: recurringPayment?.id })

    if (response.data.error) {
      recurringPaymentProxy.apiCall.error = response.data.error
    } else {
      recurringPaymentProxy.futureOccurrences = response.data.data.futureDates ?? []
    }
  } catch (e) {
    if (e instanceof Error) {
      recurringPaymentProxy.apiCall.error = e.message
    }
  } finally {
    recurringPaymentProxy.apiCall.loading = false
  }
}
